import { useRef, useState } from 'react';
import { uploadFile, UploadFolder } from '../../../services/api/uploadService';
import { Button } from '../../ui/Button/Button';
import { useToast } from '../../ui/Toast/Toast';

/** Bill photo / PDF upload button. */
export function BillUpload({ value, onChange, folder = 'bills' }: { value?: string; onChange: (path: string) => void; folder?: UploadFolder }) {
  const ref = useRef<HTMLInputElement>(null);
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-[13px] font-medium text-navy-700">Bill photo</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" leftIcon={value ? 'checkCircle' : 'download'} loading={busy} onClick={() => ref.current?.click()}>
          {value ? 'Replace bill' : 'Upload bill'}
        </Button>
        {value && <Button variant="ghost" onClick={() => onChange('')}>Remove</Button>}
      </div>
      <input
        ref={ref}
        type="file"
        accept="image/jpeg,image/png,image/webp,application/pdf"
        hidden
        onChange={async (e) => {
          const f = e.target.files?.[0];
          e.target.value = '';
          if (!f) return;
          setBusy(true);
          try {
            onChange(await uploadFile(f, folder));
            toast.success('Bill uploaded');
          } catch (err) {
            toast.error(err.message);
          } finally {
            setBusy(false);
          }
        }}
      />
      <span className="text-[13px] text-ink-400">{value ? 'Bill attached' : 'Photo or PDF, optional'}</span>
    </div>
  );
}

export default BillUpload;
